export default __webpack_public_path__ + "images/movr_0fb2fa.svg";